import React from 'react'

import { Button, PriceString } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { HtmlWithLinks } from './HtmlWithLinks/HtmlWithLinks'
import * as S from './styled'
import type { Props } from './types'

export const Campaign = ({
  title,
  description,
  bonusSummary,
  incentives,
  campaignIncentives,
  onDismiss,
}: Props) => {
  const bonusProgressPercentage =
    (bonusSummary.totalReceived.value * 100) / bonusSummary.totalAvailable.value

  // Check if campaign only has DOUBLE_SIGNUP_REFERRAL_BONUS incentive
  const hasOnlyDoubleReferralBonus =
    campaignIncentives.length === 1 && campaignIncentives[0].type === 'DOUBLE_SIGNUP_REFERRAL_BONUS'

  // For DOUBLE_SIGNUP_REFERRAL_BONUS campaigns, use the incentive's isCompleted status
  const isCompleted = bonusProgressPercentage === 100

  const showProgressBar = !hasOnlyDoubleReferralBonus

  return (
    <S.Container>
      <S.Header $noProgressBar={!showProgressBar}>
        <S.Headings>
          <S.Title>{title}</S.Title>
          <S.Description>
            <HtmlWithLinks html={description} />
          </S.Description>

          {!hasOnlyDoubleReferralBonus && isCompleted && (
            <S.Buttons>
              <Button
                label="Order samples"
                appearance="primary"
                size="xsmall"
                to={routing.settings.samples.order}
                analytics="campaignOrderSamples"
              />
              <Button
                label="Hide recommendation"
                appearance="secondary"
                size="xsmall"
                analytics="campaignHideRecommendation"
                onClick={onDismiss}
              />
            </S.Buttons>
          )}
        </S.Headings>
        {showProgressBar && (
          <CircleProgress
            progress={bonusProgressPercentage}
            earnedBonus={bonusSummary.totalReceived.value}
          />
        )}
      </S.Header>

      {incentives}
    </S.Container>
  )
}

const CircleProgress = ({ progress, earnedBonus }: { progress: number; earnedBonus: number }) => {
  return (
    // @ts-ignore
    <S.CircleProgress style={{ '--progress': `${progress}%` }}>
      <S.CircleProgressText>
        <PriceString value={earnedBonus} />
      </S.CircleProgressText>
    </S.CircleProgress>
  )
}
